import axios from "axios";


export const searchMessages = (input) => {
    return axios.post("/api/services/app/GenericMessaging/SearchMessages", input);
};
export function getAllMessages() {
    return axios.get("/api/services/app/GenericMessaging/GetAllMessages");
}